/**
 * GraphQL queries for expense management operations
 * Requirements: 9.1 - GraphQL queries support
 */

export const GET_MY_EXPENSES = `
  query GetMyExpenses(
    $status: ExpenseStatus
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    getMyExpenses(
      status: $status
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        title
        category
        amount
        date
        description
        paymentMethod
        status
        submitterId
        receipts {
          id
          fileName
          fileUrl
          fileType
          fileSize
          uploadedAt
        }
        approvals {
          id
          approverId
          status
          comments
          level
          timestamp
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;

export const GET_TEAM_EXPENSES = `
  query GetTeamExpenses(
    $status: ExpenseStatus
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    getTeamExpenses(
      status: $status
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        title
        category
        amount
        date
        description
        paymentMethod
        status
        submitterId
        receipts {
          id
          fileName
          fileUrl
          fileType
          fileSize
          uploadedAt
        }
        approvals {
          id
          approverId
          status
          comments
          level
          timestamp
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;

export const GET_ALL_EXPENSES = `
  query GetAllExpenses(
    $status: ExpenseStatus
    $department: String
    $dateFrom: AWSDate
    $dateTo: AWSDate
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    getAllExpenses(
      status: $status
      department: $department
      dateFrom: $dateFrom
      dateTo: $dateTo
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        title
        category
        amount
        date
        description
        paymentMethod
        status
        submitterId
        receipts {
          id
          fileName
          fileUrl
          fileType
          fileSize
          uploadedAt
        }
        approvals {
          id
          approverId
          status
          comments
          level
          timestamp
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;

export const GET_EXPENSE_BY_ID = `
  query GetExpenseById($id: ID!) {
    getExpenseById(id: $id) {
      id
      title
      category
      amount
      date
      description
      paymentMethod
      status
      submitterId
      receipts {
        id
        fileName
        fileUrl
        fileType
        fileSize
        uploadedAt
      }
      approvals {
        id
        approverId
        status
        comments
        level
        timestamp
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_DASHBOARD_SUMMARY = `
  query GetDashboardSummary {
    getDashboardSummary {
      totalSubmitted
      totalPending
      totalApproved
      totalRejected
      totalReimbursed
      monthlyTrend {
        month
        amount
      }
      categoryBreakdown {
        category
        amount
        count
      }
    }
  }
`;

export const GET_USER_PROFILE = `
  query GetUserProfile {
    getUserProfile {
      id
      email
      name
      employeeId
      department
      managerEmail
      role
      shift
      dateOfJoining
      createdAt
      updatedAt
    }
  }
`;

export const GET_CATEGORIES = `
  query GetCategories {
    listCategories {
      id
      name
      description
      isActive
      maxAmount
      requiresReceipt
    }
  }
`;

export const GET_ALL_USERS = `
  query GetAllUsers {
    getAllUsers {
      id
      email
      name
      employeeId
      department
      managerEmail
      role
      shift
      dateOfJoining
      createdAt
      updatedAt
    }
  }
`;

export const GET_APP_SETTING = `
  query GetAppSetting($id: ID!) {
    getAppSetting(id: $id) {
      id
      value
      updatedAt
      updatedBy
    }
  }
`;
